import { TableBody as MUITableBody } from '@mui/material';

import { TableRow } from './TableRow';

export const TableBody = ({
  callLogs,
  selectedCallRecordingIDs,
  onSelectRow,
}) => {
  return (
    <MUITableBody>
      {callLogs.map(callLog => {
        const isRowChecked = selectedCallRecordingIDs.has(
          callLog.callRecordingID,
        );

        return (
          <TableRow
            key={callLog.callRecordingID}
            callLog={callLog}
            isRowChecked={isRowChecked}
            onSelectRow={onSelectRow}
          />
        );
      })}
    </MUITableBody>
  );
};
